import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { setSuccess } from "../../../Redux/AlertReducer";
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableCell,
  TextField,
} from "@mui/material";
import OfferModal from "./servicesModal";
import TableHead from "../../Table/TableHead";
import TableRow from "../../Table/TableRow";
import TableData from "../../Table/TableData";
import { FaTrashAlt } from "react-icons/fa";
import { setOpen } from "../../../Redux/ModalReducer";
import { errorToaster } from "../../../helper/toasterConfiguration";
import Data from "../../common/custom-modal/Data";

export const OfferForm = ({ services }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    note: "",
    services: [],
    total_price: 0,
    active: 1,
    discount: 0,
    discount_type: "$",
  });

  const finalPrice =
    formData.discount > 0
      ? formData.discount_type === "$"
        ? Math.max(formData.total_price - formData.discount, 0)
        : Math.max(
            formData.total_price -
              (formData.total_price * formData.discount) / 100,
            0
          )
      : formData.total_price;

  const handleAddService = (service) => {
    const updatedServices = [...formData.services, service];

    setFormData((prev) => ({
      ...prev,
      services: updatedServices,
    }));
  };

  const removeService = (index) => {
    const updatedServices = [...formData.services];
    updatedServices.splice(index, 1);

    setFormData((prev) => ({
      ...prev,
      services: updatedServices,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.services.length === 0) {
      errorToaster("you should have at least one service");
      return;
    }

    setIsLoading(true);

    const finalPrice =
      formData.discount > 0
        ? formData.discount_type === "$"
          ? Math.max(formData.total_price - formData.discount, 0)
          : Math.max(
              formData.total_price -
                (formData.total_price * formData.discount) / 100,
              0
            )
        : formData.total_price;

    const formDataToSend = new FormData();
    // Clone formData but exclude the 'price' field from services
    const filteredServices = formData.services.map(
      ({ ourServiceId, days, countTicket, description }) => ({
        our_service_id: ourServiceId,
        days,
        countTicket,
        description,
      })
    );

    // Append other form data
    for (let key in formData) {
      if (formData[key] !== null && key !== "services") {
        if (key === "discount") {
          formDataToSend.append(
            key,
            formData.discount.length > 0
              ? formData.discount < 0
                ? 0
                : formData.discount_type === "$"
                ? formData.discount > formData.total_price
                  ? formData.total_price
                  : formData.discount
                : finalPrice === 0
                ? 100
                : formData.discount
              : 0
          );
        } else {
          formDataToSend.append(key, formData[key]);
        }
      }
    }

    // Append filtered services separately
    filteredServices.forEach((method, index) => {
      const { our_service_id, days, countTicket, description } = method;
      formDataToSend.append(
        `details[${index}][our_service_id]`,
        our_service_id
      );
      formDataToSend.append(`details[${index}][days]`, days);
      formDataToSend.append(`details[${index}][count_ticket]`, countTicket);
      formDataToSend.append(`details[${index}][description]`, description);
    });

    formDataToSend.append("final_price", finalPrice);

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Offers.Add,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoading(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Offers");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          required
          autoComplete="off"
          value={formData.title}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Note"
          name="note"
          autoComplete="off"
          value={formData.note}
          onChange={handleInputChange}
          variant="outlined"
        />
        <div className="mt-3">
          <div className="w-full flex items-start">
            <Button
              variant="contained"
              onClick={() => {
                setModalVisible(true);
                dispatch(setOpen(true));
              }}
              className="mt-4"
            >
              Add Offer Data
            </Button>
          </div>

          <OfferModal
            show={modalVisible}
            formData={formData}
            handleClose={() => {
              setModalVisible(false);
              dispatch(setOpen(false));
            }}
            services={services}
            handleAddService={handleAddService}
          />

          <div className="mt-2">
            <h2 className="text-start text-xl font-semibold">
              Added Services:
            </h2>
            <div className="overflow-x-auto mt-4">
              <Table className="text-[13px]">
                <thead className="bg-secondary text-darkTextColor font-sans">
                  <tr>
                    <TableHead title="ID" />
                    <TableHead title="Service" />
                    <TableHead title="Days" />
                    <TableHead title="count ticket" />
                    <TableHead title="Description" />
                    <TableHead title="Actions" />
                  </tr>
                </thead>
                <tbody className="text-textColor dark:text-darkTextColor">
                  {formData.services.map((service, index) => {
                    return (
                      <TableRow key={index}>
                        <TableData title={index + 1} />
                        <TableData title={service?.ourService} />
                        <TableData title={service?.days} />
                        <TableData title={service?.countTicket} />
                        <TableCell align="center">
                          {service?.description ? (
                            <Data data={service?.description} />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                        <td className="p-2 text-center">
                          <div className="flex items-center justify-center">
                            <FaTrashAlt
                              onClick={() => {
                                removeService(index);
                              }}
                              className="text-[#d9534f] cursor-pointer"
                            />
                          </div>
                        </td>
                      </TableRow>
                    );
                  })}
                </tbody>
              </Table>
              <h4 className="mt-4 text-start flex items-center gap-4 font-semibold text-lg">
                Total Price:{" "}
                <TextField
                  margin="normal"
                  label="Total price"
                  name="total_price"
                  type="number"
                  value={formData.total_price >= 0 ? formData.total_price : 0}
                  onChange={handleInputChange}
                  variant="outlined"
                  className="w-[calc(100%-7rem)]"
                />
              </h4>
              {formData.services.length > 0 && (
                <div className="mt-4 flex flex-wrap gap-4 flex-col md:flex-row">
                  <FormControl className="w-full md:w-64" margin="normal">
                    <InputLabel>Discount Type</InputLabel>
                    <Select
                      name="discount_type"
                      value={formData.discount_type}
                      onChange={handleInputChange}
                      label="Discount Type"
                      className="text-start"
                    >
                      <MenuItem value="$">$</MenuItem>
                      <MenuItem value="%">%</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    margin="normal"
                    label="Discount"
                    name="discount"
                    type="number"
                    value={formData.discount}
                    onChange={handleInputChange}
                    variant="outlined"
                    className="w-full md:w-[calc(100%-17rem)]"
                  />
                </div>
              )}
              {formData.services.length > 0 && (
                <h4 className="mt-4 text-start font-semibold text-lg">
                  Final Price: ${finalPrice}
                </h4>
              )}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 mt-3">
          <div className="grid grid-cols-1 items-center justify-between gap-x-3">
            <div className="flex items-center justify-start gap-x-3">
              <FormLabel sx={{ fontWeight: "bold" }} component="legend">
                Active:
              </FormLabel>
              <RadioGroup
                name="active"
                value={formData.active}
                onChange={handleRadioChange}
                row
              >
                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                <FormControlLabel value="0" control={<Radio />} label="No" />
              </RadioGroup>
            </div>
          </div>
        </div>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={isLoading}
          color="primary"
          sx={{
            display: isLoading ? "flex" : "block",
            marginTop: 2,
            width: "20%",
            marginX: "auto",
            fontWeight: "bold",
            justifyContent: "center",
          }}
        >
          {isLoading ? (
            <CircularProgress size={24} color="primary" />
          ) : (
            "Submit"
          )}
        </Button>
      </form>
    </div>
  );
};
